// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { vmiUsersErrorsModalStyles } from "@insite/content-library/Components/VmiUsersErrorsModal";
import { modalButtonsActionStyles } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

vmiUsersErrorsModalStyles.modal = {
    sizeVariant: "medium",
    cssOverrides: {
        modalTitle: css`
            justify-content: flex-start;
        `,
    },
};

vmiUsersErrorsModalStyles.headerText = {
    variant: "h4",
    css: css`
        margin: 0;
    `,
};

vmiUsersErrorsModalStyles.buttonsWrapper = {
    ...modalButtonsActionStyles.buttonsGridItem,
};

vmiUsersErrorsModalStyles.cancelUploadButton = {
    ...modalButtonsActionStyles.cancelButton,
};

vmiUsersErrorsModalStyles.continueUploadButton = {
    ...modalButtonsActionStyles.submitButton,
};

vmiUsersErrorsModalStyles.dataTable = {};
